import { Injectable, inject } from '@angular/core';
import { map, of } from 'rxjs';

import { MOCK_FORM_FIELDS } from '@demo/data/demo-form-builder.const';
import { FieldsService } from '@shared/components/fields/common';

@Injectable({
  providedIn: 'root',
})
export class DemoFormBuilderService {
  private fieldsService = inject(FieldsService);
  getFormData() {
    return of(MOCK_FORM_FIELDS).pipe(map(fields => fields.map(field => this.fieldsService.mapFormFieldModel(field))));
  }
}
